module.exports = __webpack_public_path__ + "assets/ic-shake.57cc191d.svg";